/* Church Sign Shop — design landing page (/pages/design/<handle>).
   Server-rendered page; JS only (1) paints the live canvas preview of this
   design in the no-photo hero state with a shape switcher (same renderer as
   the configurator), keeping the CTA deep-link in sync with the chosen
   shape, and (2) paints the artwork into the server-rendered "More designs"
   links. Everything SEO-relevant is already in the HTML.                  */
(function () {
  var cfgEl = document.querySelector('[data-dlp-config]');
  if (!cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  var designs = [];
  try {
    var regEl = document.querySelector('[data-design-registry]');
    if (regEl) designs = JSON.parse(regEl.textContent || '[]') || [];
  } catch (e) { designs = []; }
  var byHandle = {};
  designs.forEach(function (d) { byHandle[d.handle] = d; });
  var bleedIn = parseFloat(cfg.print && cfg.print.bleedIn) || 1;
  var radiusIn = parseFloat(cfg.print && cfg.print.cornerRadiusIn);
  if (isNaN(radiusIn)) radiusIn = 1;
  var shape = 'square';

  var imgCache = {};
  function loadImg(url, cb) {
    if (!url) { cb(); return; }
    var e = imgCache[url];
    if (!e) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      e = imgCache[url] = { img: im, ready: false, cbs: [] };
      im.onload = function () { e.ready = true; e.cbs.splice(0).forEach(function (f) { f(); }); };
      im.src = url;
    }
    if (e.ready) cb(); else e.cbs.push(cb);
  }
  function paint(cv, d, shp, cssW) {
    var ST = window.SignTemplates;
    if (!ST || !cv || !d) return;
    var url = (shp === 'rectangle' && d.imgRect) ? (d.thumbRect || d.imgRect) : (shp === 'circle' && d.imgCircle) ? (d.thumbCircle || d.imgCircle) : (d.thumb || d.img);
    var sheetMatches = !(shp === 'rectangle' && !d.imgRect);
    var draw = function () {
      var e = imgCache[url];
      ST.renderPreviewInto(cv, cssW, {
        shape: shp, bleedIn: bleedIn, cornerRadiusIn: radiusIn,
        dpr: Math.min(2, window.devicePixelRatio || 1),
        drawFull: function (ctx, ppi) {
          ST.renderOverlay({ ctx: ctx, img: e && e.ready ? e.img : null,
            design: { bg: null, ink: d.ink || 'white', fields: {} },
            shape: shp, bleedIn: bleedIn, ppi: ppi, sheetMatches: sheetMatches, defaultBg: d.bg });
        }
      });
      cv.style.width = '100%'; cv.style.height = 'auto';
    };
    loadImg(url, draw); draw();
  }

  /* ── hero preview (no-photo state only) ─────────────────────────── */
  var me = byHandle[cfg.handle] || { img: cfg.img, imgRect: null, imgCircle: null, bg: cfg.bg, ink: cfg.ink };
  var mainCv = document.querySelector('[data-dlp-canvas]');
  var ctas = Array.prototype.slice.call(document.querySelectorAll('[data-dlp-cta]'));
  function syncCta() {
    var href = cfg.productUrl + '?design=' + encodeURIComponent(cfg.handle) + (shape !== 'square' ? '&shape=' + shape : '');
    ctas.forEach(function (a) { a.href = href; });
  }
  function drawMain() {
    if (!mainCv) return;
    var frame = mainCv.parentElement;
    var cssW = Math.max(160, Math.min(420, (frame && frame.clientWidth) || 360));
    paint(mainCv, me, shape, cssW);
  }
  document.querySelectorAll('[data-dlp-shape]').forEach(function (b) {
    b.addEventListener('click', function () {
      shape = b.getAttribute('data-dlp-shape');
      document.querySelectorAll('[data-dlp-shape]').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      drawMain(); syncCta();
    });
  });

  /* ── "More designs" tiles (links are server-rendered) ───────────── */
  var moreCards = Array.prototype.slice.call(document.querySelectorAll('[data-dlp-more-card]'));
  function drawMore() {
    moreCards.forEach(function (a) {
      var d = byHandle[a.getAttribute('data-handle')];
      var cv = a.querySelector('canvas');
      if (!d || !cv) return;
      var w = Math.max(80, Math.min(240, (cv.parentElement.clientWidth - 20) || 160));
      paint(cv, d, 'square', w);
    });
  }

  function start() {
    if (!window.SignTemplates) { setTimeout(start, 60); return; }
    var f = window.SignTemplates.loadFonts ? window.SignTemplates.loadFonts() : Promise.resolve();
    f.then(function () { drawMain(); drawMore(); });
  }
  start();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { drawMain(); drawMore(); }, 80); });
})();
